import * as Mapbox from 'mapbox-gl';

export let currentMapGlobal: Mapbox.Map | undefined;

export const setCurrentMap = (map: Mapbox.Map) => {
	currentMapGlobal = map;
};
